export {
  CruisePriceTable,
  type CruisePriceTableProps,
  type CruisePriceTableLineItem,
} from '../../compositions/my-trips/cruise-price/CruisePriceTable';
